import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { showPopupNew } from '../../actions/popup-actions';
import { PopupTypes, SubscriptionIntervalTypes } from '../../utils/constants';
import { PowerFunnelSurfaces } from '../Analytics/constants';

const SUBSCRIPTIONS_PATH = '/subscriptions';

const useCollegeProspectAccess = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isPowered = useSelector((state) => !!state.auth?.user?.isPowered);
    const hasAnnualPower = useSelector((state) => (
        !!state.auth?.user?.isPowered &&
        state.auth?.user?.subscriptionTierType === SubscriptionIntervalTypes.YEAR
    ));
    const hasPastDueSubscription = useSelector((state) => !!state.auth?.user?.hasPastDueSubscription);

    const openUpgradePopup = (gatedFeature) => {
        if (hasPastDueSubscription) {
            history.push(SUBSCRIPTIONS_PATH);
            return;
        }
        dispatch(showPopupNew({
            popup: isPowered
                ? PopupTypes.POWER_MONTHLY_UPGRADE_POPUP
                : PopupTypes.UPGRADE_TO_POWER_POPUP,
            referringSurface: PowerFunnelSurfaces.PLAYER_PROFILE_COLLEGE_PROSPECT,
            gatedFeature,
        }));
    };

    return { isPowered, hasAnnualPower, hasPastDueSubscription, openUpgradePopup };
};

export default useCollegeProspectAccess;
